import { NotificationsPausedTwoTone, WarningTwoTone } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { IParams, Page, Widget } from '../../../shared';
import { SupportCaseTitle } from '../../components';
import { DuplicatesTable } from '../../components/duplicates-table/duplicates-table.component';
import { useGetSupportCase, useSupportCaseDuplicates } from '../../hooks';

export const SupportCaseDuplicatesPage: FC = () => {
    const { t } = useTranslation();
    const { id } = useParams<keyof IParams>() as IParams;

    const navigate = useNavigate();

    const { data: supportCase, isLoading: supportCaseIsLoading } = useGetSupportCase(id);
    const { data: duplicates, isLoading: duplicatesIsLoading } = useSupportCaseDuplicates(id, true);

    const noDuplicates = (duplicates || []).filter((duplicate) =>
        duplicate.noDuplicates.some(({ supportCaseId }) => supportCaseId === id),
    );
    const duplicateWarnings = (duplicates || []).filter(
        (duplicate) => !duplicate.noDuplicates.some(({ supportCaseId }) => supportCaseId === id),
    );
    return (
        <Page
            onBack={() => navigate(-1)}
            title={supportCase && <SupportCaseTitle supportCase={supportCase} />}
            loading={supportCaseIsLoading || duplicatesIsLoading || !duplicates}
        >
            <Stack spacing={2}>
                <Widget icon={<WarningTwoTone color="primary" />} title={t('foundDuplicates')} hasTable>
                    {duplicateWarnings?.length ? (
                        <DuplicatesTable duplicates={duplicateWarnings} supportCase={supportCase} />
                    ) : (
                        <Typography m={2}>{t('noDuplicatesFound')}</Typography>
                    )}
                </Widget>
                <Widget icon={<NotificationsPausedTwoTone color="primary" />} title={t('markedAsNoDuplicate')} hasTable>
                    {noDuplicates?.length ? (
                        <DuplicatesTable duplicates={noDuplicates} supportCase={supportCase} />
                    ) : (
                        <Typography m={2}>{t('noDuplicatesFound')}</Typography>
                    )}
                </Widget>
            </Stack>
        </Page>
    );
};
